import jwtDecode from 'jwt-decode';
import { User } from '../interfaces';

interface JwtPayload {
  sub: string;
  email: string;
  jti: string;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string | string[];
  exp: number;
  iss: string;
  aud: string;
  name: string;
  userId: string;
  isBusiness: string;
  phoneNumber: string;
}

export const decodeJwtToken = (token: string): User => {
  try {
    const decoded = jwtDecode<JwtPayload>(token);
    
    let roles: string[] = [];
    const roleClaim = decoded['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    
    if (typeof roleClaim === 'string') {
      roles = [roleClaim];
    } else if (Array.isArray(roleClaim)) {
      roles = roleClaim;
    }

    const user: User = {
      token: token,
      username: decoded.sub || decoded.email,
      emailAddress: decoded.email,
      name: decoded.name || decoded.email,
      userId: Number(decoded.userId),
      isBusiness: decoded.isBusiness === 'true' || decoded.isBusiness === 'True',
      phoneNumber: decoded.phoneNumber || '',
      roles: roles
    };

    return user;
  } catch (error) {
    console.error('JWT decode error:', error);
    throw new Error('Failed to decode JWT token');
  }
};
